import OpsMembers from '@/features/companyDashboard/ops/members/OpsMembers';

const CompanyMembers = () => <OpsMembers />;

export default CompanyMembers;
